import React, { Component, PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import { removeAccountRequest } from 'common/ducks/user';
import { SubmissionError } from 'redux-form';
import RemoveAccountForm from 'account/components/remove_account_form';

/**
 * Account removal modal.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class RemoveAccountModal extends Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit() {
    const { user, logout } = this.props
    return removeAccountRequest(user.profile_data.id)
      .then(() => logout('/account/removed'))
      .catch((res) => {
        throw new SubmissionError({ _error: 'Failed to remove account. Please try again.' });
      });
  }

  render() {
    const {showing, onClose, user: {profile_data: is_creative}} = this.props

    return (
      <ModalDialog
        modalOpen={showing}
        dialogClasses="remove-account"
        modalHeader="Delete Account"
        closeAction={onClose}
      >
        <h2>Whoa! Are you sure you want to delete your account?</h2>
        <p>
          If you delete your account, you will lose your
          username{is_creative? ",":" and"} reputation
          score{is_creative && ", portfolio items, and payment history"}. If you choose
          to signup again, you'll need to go through the sign up process again
          {is_creative && " and re-verify your ID and work"}.
        </p>

        <p>To delete your account, type <span className="text-danger">DELETE</span> below.</p>

        <RemoveAccountForm onSubmit={this.handleSubmit} onCancel={onClose}/>
      </ModalDialog>
    )
  }
}

/**
 * PropTypes.
 *
 * @property {object} user - logged in user
 * @property {bool} showing - whether to show this modal
 * @property {func} onClose - called to close this modal
 *
 */
RemoveAccountModal.propTypes = {
  user: PropTypes.object,
  showing: PropTypes.bool,
  onClose: PropTypes.func,
};



// WEBPACK FOOTER //
// ./account/components/remove_account_modal.jsx